import { NewsletterEmailInfoView } from "../Views/NewsletterEmailInfoView";

export const NewsletterEmailInfoPage = (props: { location: any }) => {
	return <NewsletterEmailInfoView />;
};
